// src/types/old-types-mapping/index.ts
import { INVOICE_REVIEW_STATUSES, CUSTOMER_RELATION_TYPES } from "@vy/types";

// src/predicates/is-invoice-customer-child-of-accumulation.ts
var ACCUMULATION_RELATION_TYPES = /* @__PURE__ */ new Set([
  CUSTOMER_RELATION_TYPES.accumulateUsage,
  CUSTOMER_RELATION_TYPES.accumulateCharges
]);
function isInvoiceCustomerChildOfAccumulation(invoice) {
  const relationType = invoice.customer.parentCustomer?.relationType;
  return relationType !== void 0 && ACCUMULATION_RELATION_TYPES.has(relationType);
}

// src/predicates/is-invoice-approvable.ts
function isInvoiceApprovable(invoice) {
  if (invoice.reviewStatus !== INVOICE_REVIEW_STATUSES.InReview) {
    return false;
  }
  return !isInvoiceCustomerChildOfAccumulation(invoice);
}

// src/predicates/is-draft-invoice-approvable.ts
function isDraftInvoiceApprovable(invoice) {
  if (invoice.reviewStatus !== INVOICE_REVIEW_STATUSES.Draft) {
    return false;
  }
  return !isInvoiceCustomerChildOfAccumulation(invoice);
}

// src/predicates/is-invoice-sync-to-integration-allowed.ts
function isInvoiceSyncToIntegrationAllowed(invoice) {
  if (invoice.reviewStatus !== INVOICE_REVIEW_STATUSES.Approved) {
    return false;
  }
  return !isInvoiceCustomerChildOfAccumulation(invoice);
}

// src/services/get-invoice-remaining-amount.ts
import { notDefined } from "@vy/null";
import { sumBy } from "@vy/number";
function getInvoiceRemainingAmount(invoiceTotal, payments) {
  const totalPaid = notDefined(payments) ? 0 : sumBy(payments, (payment) => payment.amount);
  return Math.max(0, invoiceTotal - totalPaid);
}
export {
  getInvoiceRemainingAmount,
  isDraftInvoiceApprovable,
  isInvoiceApprovable,
  isInvoiceCustomerChildOfAccumulation,
  isInvoiceSyncToIntegrationAllowed
};
